export const startOfDay = (date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

export const endOfDay = (date) => {
  const next = new Date(date);
  next.setHours(23, 59, 59, 999);
  return next;
};

export const addDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export const getSundayKickoff = (baseDate = new Date()) => {
  const next = startOfDay(baseDate);
  const day = next.getDay();
  const diff = (7 - day) % 7;
  next.setDate(next.getDate() + diff);
  return next;
};

export const getRemainingMonthlyKickoffs = (baseDate = new Date()) => {
  const normalizedBaseDate = startOfDay(baseDate);
  const month = normalizedBaseDate.getMonth();
  const year = normalizedBaseDate.getFullYear();
  const firstKickoff = getSundayKickoff(normalizedBaseDate);
  const kickoffs = [];

  for (let date = new Date(firstKickoff); ; date = addDays(date, 7)) {
    const weekStart = addDays(startOfDay(date), 1);
    const belongsToRequestedMonth =
      weekStart.getMonth() === month && weekStart.getFullYear() === year;

    if (!belongsToRequestedMonth) break;
    kickoffs.push(startOfDay(date));
  }

  return kickoffs;
};

export const getSeasonKickoffs = (baseDate = new Date(), weeks = 12) => {
  const firstKickoff = getSundayKickoff(baseDate);
  return Array.from({ length: weeks }, (_, index) => addDays(firstKickoff, index * 7));
};

export const buildWeekWindowFromKickoff = (kickoffDate) => {
  const kickoffAt = startOfDay(kickoffDate);
  const weekStart = startOfDay(new Date(kickoffAt));
  weekStart.setDate(weekStart.getDate() + 1);

  const weekEnd = endOfDay(new Date(weekStart));
  weekEnd.setDate(weekEnd.getDate() + 6);

  return { kickoffAt, weekStart, weekEnd };
};

export const isGmMatchExpired = (match, referenceDate = new Date()) =>
  Boolean(
    match?.status === 'open' &&
      match?.weekEnd &&
      endOfDay(match.weekEnd).getTime() <= referenceDate.getTime()
  );

export const buildClosedGmMatchState = ({
  match,
  weeklyScoresByFaction = {},
  getParticipantDisplayName = () => 'Fazione',
  closedAt = new Date(),
}) => {
  const participantsForResult = (match?.participants || []).map((participant) => ({
    factionId: participant.factionId,
    factionName: participant.factionName,
    ownerUid: participant.ownerUid || null,
    weeklyScore: weeklyScoresByFaction[participant.factionId] || 0,
  }));

  const topScore = participantsForResult.reduce(
    (max, participant) => Math.max(max, participant.weeklyScore),
    Number.NEGATIVE_INFINITY
  );
  const winners = participantsForResult.filter(
    (participant) => participant.weeklyScore === topScore
  );
  const isTie = winners.length > 1;

  const results = participantsForResult.map((participant) => {
    const isWinner = winners.some((winner) => winner.factionId === participant.factionId);

    return {
      ...participant,
      matchPoints: isWinner ? (isTie ? 1 : participantsForResult.length) : 0,
      isWinner,
    };
  });

  const winnerIds = winners.map((winner) => winner.factionId);
  const winnerNames = winners.map((winner) => winner.factionName);
  const winnerPlayerNames = winners.map((winner) => getParticipantDisplayName(winner));

  return {
    status: 'closed',
    results,
    winnerIds,
    winnerNames,
    winnerPlayerNames,
    winnerId: !isTie && winnerIds.length === 1 ? winnerIds[0] : null,
    winnerName: !isTie && winnerNames.length === 1 ? winnerNames[0] : null,
    winnerPlayerName: !isTie && winnerPlayerNames.length === 1 ? winnerPlayerNames[0] : null,
    closedAt,
  };
};
